/* eslint-disable react/forbid-prop-types */
import { Button, ButtonGroup, Card, Col, Row } from "react-bootstrap";
import { CalendarIcon, ChevronRightIcon, ClockIcon, DesktopComputerIcon, LocationMarkerIcon } from "@heroicons/react/outline";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";

import EventPopoverButton from "../EventPopoverButton";
import ShareClassButton from "../../../components/ShareClassButton";
import { displayDate } from "../../../helpers/dates";

const timeFormat = "h:mm a";
const iconClasses = "i me-2 color-bluesky";

const CardEventsList = ({
	events
}) => (
	<Card>
		<Card.Header className="px-5">
			<Row className="py-2">
				<Col md={9}>
					Class Info
				</Col>
				<Col md={3}>
					Date &amp; Location
				</Col>
			</Row>
		</Card.Header>
		<Card.Body className="px-5">
			{events.map((dayEvent, idx) => (
				<Row className={classNames("border-neutral9 py-5", { "border-bottom": idx !== events.length - 1 })} key={dayEvent.id}>
					<Col md={9}>
						<h3><Link className="text-dark" to={`/class/${dayEvent.id}`}>{dayEvent.title}</Link></h3>
						<div dangerouslySetInnerHTML={{ __html: dayEvent.description }} />
						<ButtonGroup className="mb-4">
							<Button as={Link} to={`/class/${dayEvent.id}`} variant="link">
								Find Out More <ChevronRightIcon className="i ms-2" />
							</Button>
							<ShareClassButton course={dayEvent} variant="link" />
						</ButtonGroup>
					</Col>
					<Col className="fs-18" md={3}>
						<div className="mb-2">
							<CalendarIcon className={iconClasses} />
							&nbsp;
							{displayDate(dayEvent.start, "LLL do, yyy")}
						</div>
						<div className="mb-2">
							<ClockIcon className={iconClasses} />
							&nbsp;
							{displayDate(dayEvent.start, timeFormat)} - {displayDate(dayEvent.end, timeFormat)}
						</div>
						<div className="mb-4">
							{dayEvent.type === "online"
								? <DesktopComputerIcon className={iconClasses} />
								: <LocationMarkerIcon className={iconClasses} />}
							&nbsp;
							{dayEvent.location}
						</div>

						<EventPopoverButton className="w-100" course={dayEvent} />

					</Col>
				</Row>
			))}
		</Card.Body>
	</Card>
);

CardEventsList.propTypes = {
	events: PropTypes.arrayOf(PropTypes.shape({
		description: PropTypes.string,
		end: PropTypes.object,
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		location: PropTypes.string,
		start: PropTypes.object,
		title: PropTypes.string
	}))
};

CardEventsList.defaultProps = {
	events: []
};

export default CardEventsList;
